import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=e3fb523c&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=e3fb523c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fb523c",
  null
  
)

export default component.exports